import appAxios from "services/axios";

class IntegrationsAdminService {
    connectGoogleSheets = async () => {
        const orgID = localStorage.getItem("orgID");
        if (!orgID) {
            throw new Error("Org ID is not found");
        }
        return appAxios.get(`/auth/integrations/google-sheet/connect?orgID=${orgID}`);
    };
    status = async (type: string) => {
        const orgID = localStorage.getItem("orgID");
        if (!orgID) {
            throw new Error("Org ID is not found");
        }
        return appAxios.get(`/auth/integrations/google-sheet/status?orgID=${orgID}&type=${type}`);
    };
    disconnectGoogleSheets = async () => {
        const orgID = localStorage.getItem("orgID");
        if (!orgID) {
            throw new Error("Org ID is not found");
        }
        return appAxios.post(`/admin/orgs/${orgID}/google-sheets/disconnect`);
    };
}

export default new IntegrationsAdminService();
